<!--DEV NOTE: please include all the configuration to work with themes. Same was made in vue-ui -->
<template>
	<div class="nav vue-header" :mode="activeMode" :style="brandingVars">
		<div class="vue-header__left-col">
			<div class="vue-header__logo" tabindex="0" @click="gotoDashboard">
				<VUELogoVonly class="vue-header__logo--mobile" />
				<VUELogo
					class="vue-header__logo--desktop"
					data-testid="header-logo"
				/>
			</div>
			<hr class="vue-header__vertical-div" />
			<button
				class="vue-header__menu-btn"
				:class="isMenuOpen && 'is-open'"
				@click="handleMenu"
				v-if="showMenuButton"
				data-testid="menu-button"
				id="menu-button"
			>
				<i class="icon icon-menu-2" id="menu-button-icon"></i>
			</button>
		</div>
		<div class="vue-header__right-col">
			<div class="vue-header__search">
				<VueGlobalSearch
					v-if="showGlobalSearch"
					data-testid="global-search"
				/>
			</div>
			<div class="vue-header__notification">
				<VueNotifications
					v-if="showNotifications"
					data-testid="notification-list"
				/>
			</div>
			<div
				:class="['vue-header__help']"
				v-if="showHelp"
				@click="onHelpClick"
			>
				<VueHelp class="vue-header__help" data-testid="help" />
			</div>
			<hr
				class="vue-header__vertical-div"
				v-if="showVerticalLine"
				data-testid="verticalDiv"
			/>
			<div class="vue-header__profile-menu">
				<VueProfileMenu
					v-if="showProfileMenu"
					data-testid="profile-menu"
				/>
			</div>
			<div class="vue-header__company-selector">
				<VueCompanySelector
					v-if="showCompanySelector"
					data-testid="company-selector"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import VueCompanySelector from './components/vue-company-selector.vue';
import VueHelp from './components/vue-help.vue';
import VueProfileMenu from './components/vue-profile-menu.vue';
import VueNotifications from './components/vue-notifications.vue';
import VueGlobalSearch from './components/vue-global-search.vue';
import propsMixin from './mixins/parent-component-props';
import getCompanyId from '@/composables/get-companyid';
import { mapGetters, mapActions } from 'vuex';
import VUELogo from '@/assets/icons/vue_logo.svg?inline';
import VUELogoVonly from '@/assets/icons/vue_logo-v-only.svg?inline';

export default {
	name: 'VueUiHeader',
	data() {
		return {
			reponsibleForUserInfo: false,
			activeMode: 'light',
			brandingVars: {},
			displayHelp: false,
			helpCloseHandlerSet: false
		};
	},
	components: {
		VueCompanySelector,
		VueHelp,
		VueProfileMenu,
		VueNotifications,
		VueGlobalSearch,
		VUELogo,
		VUELogoVonly
	},
	mixins: [propsMixin],
	props: {
		hideMenuButton: {
			type: Boolean,
			default: false
		},
		hideGlobalSearch: {
			type: Boolean,
			default: false
		},
		hideNotifications: {
			type: Boolean,
			default: false
		},
		hideHelp: {
			type: Boolean,
			default: false
		},
		hideProfileMenu: {
			type: Boolean,
			default: false
		},
		hideCompanySelector: {
			type: Boolean,
			default: false
		}
	},
	created() {
		window.LLHeader = true;
	},
	computed: {
		...mapGetters('user', ['pageTitle', 'userToken', 'isMenuOpen']),
		showMenuButton() {
			return this.initialized && !this.hideMenuButton;
		},
		showGlobalSearch() {
			return this.initialized && !this.hideGlobalSearch;
		},
		showNotifications() {
			return this.initialized && !this.hideNotifications;
		},
		showHelp() {
			return !this.hideHelp;
		},
		showProfileMenu() {
			return this.initialized && !this.hideProfileMenu;
		},
		showCompanySelector() {
			return this.initialized && !this.hideCompanySelector;
		},
		showVerticalLine() {
			let result = false;

			//if one element on the left and one on the right are visible, it should show
			if (
				(this.showGlobalSearch ||
					this.showNotifications ||
					this.showHelp) &&
				(this.showProfileMenu || this.showCompanySelector)
			) {
				result = true;
			}

			return result;
		}
	},
	methods: {
		...mapActions('user', ['setMenuIsOpen']),
		removeToastAction() {},
		handleMenu() {
			this.setMenuIsOpen(!this.isMenuOpen);
		},
		gotoDashboard() {
			const cid = getCompanyId(this.$route);
			let location = '/';
			if (cid != undefined) {
				location = `/?cid=${cid}`;
			}
			window.location.assign(location);
		},
		onHelpClick() {
			// const self = this;

			this.displayHelp = !this.displayHelp;

			// if (window.HubSpotConversations && !this.helpCloseHandlerSet) {
			// 	window.Intercom('onHide', function() {
			// 		self.displayHelp = false;
			// 		self.helpCloseHandlerSet = true;
			// 	});
			// }
		}
	}
};
</script>

<style lang="scss" scoped>
.vue-header {
	position: fixed;
	top: 0;
	width: 100%;
	max-width: 1402px;
	height: 48px;
	border-bottom: 1px solid $neutral-2;
	display: flex;
	justify-content: space-between;
	background: var(--bg-0);
	color: var(--bg-0-fg-4);
	z-index: $z-level5;

	&__logo-breadcrumb {
		height: 100%;
		display: flex;
		align-items: center;
	}

	&__menu-btn {
		font-size: 14px;
		height: 100%;
		min-width: 42px;
		border-radius: 0;

		&.is-open {
			background: var(--menu-list-bg-active);
			color: var(--menu-list-fg-active);

			@include mq($until: sm-l) {
				background: var(--bg-brand-1);
				color: var(--bg-0);
			}
		}

		@include mq($from: md-l) {
			&:hover:not(.is-open) {
				background: var(--menu-list-bg-hover);
				color: var(--menu-list-fg-hover);
			}
		}

		@include mq($from: md-l) {
			display: none;
		}

		@include header-focus-styles;
	}

	&__logo {
		min-width: 42px;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 $padding-xs;
		cursor: pointer;

		&-img,
		&-img-mobile {
			height: 80%;
		}

		&-img {
			display: none;
		}

		@include mq($from: md) {
			&-img {
				display: inline-block;
			}

			&-img-mobile {
				display: none;
			}
		}

		@include header-focus-styles;
	}

	&__left-col {
		margin-left: $gutter-sm;
		display: flex;
		align-items: center;

		.vue-header__vertical-div {
			display: none;
			margin-right: $gutter-md;
			margin-left: $gutter-lg;

			@include mq($until: md-l) {
				display: inline-block;
			}
		}
	}

	&__logo {
		> * {
			height: 30px;
		}

		&--mobile {
			@include mq($from: md-l) {
				display: none;
			}
		}

		&--desktop {
			display: none;

			@include mq($from: md-l) {
				display: inline-block;
				margin-left: 0.5px;
			}
		}
	}

	&__right-col {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		flex-grow: 2;

		> * {
			min-width: 42px;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.vue-header__vertical-div {
			margin: 0 $gutter-lg;
		}
	}

	&__vertical-div {
		display: inline-block;
		min-width: initial;
		width: 1px;
		height: 60%;
		padding: 0;
		border-width: 0;
		background: var(--bg-0-fg-1);
	}

	&__search {
		margin-left: $gutter-md;

		@include mq($from: md) {
			margin-left: $gutter-xl;
		}
		flex-grow: 2;
		min-width: 42px;
	}

	&__notification {
		z-index: $z-level1-1;
	}

	&__help.is-open .launch-intercom {
		background-image: linear-gradient(
			-225deg,
			rgb(80, 204, 204) 35%,
			rgb(69, 174, 202) 100%
		);
		color: $ui-fg-light;
	}

	&__profile-menu,
	&__company-selector {
		min-width: max-content;
	}
}

@media print {
	.vue-header {
		display: none;
		visibility: hidden;
	}
}
</style>
